<p>Aby zapenić bezproblemowe świadczenie usługi, serwis look@menu korzysta z ciasteczek. Ciasteczka są również wykorzystywane do celów statystycznych. 
    Dalsze korzystanie z serwisu oznacza, że zgadzasz się na ich użycie. <br />Więcej informacji w <a href="/privacy-policy">Polityce prywatności</a></p>
<button mat-flat-button color="primary" (click)="snackBarRef.dismiss()">Akceptuję</button>

